// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__35rhB","loaderOuter":"PageOverlayLoader_loaderOuter__3MBZo"};